import React from "react";
import { Helmet } from "react-helmet";
import "../styles/legalsites.css";

const PrivacyPolicy = () => {
  return (
    <section id="privacy" className="legal-section">
      <Helmet>
        <title>Adatvédelmi tájékoztató – DentiCare Fogászat</title>
        <meta
          name="description"
          content="A denticare.hu adatvédelmi tájékoztatója a GDPR és az Info tv. alapján. Személyes adatok kezelése fogászati szolgáltatás esetén."
        />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://denticare.hu/adatvedelmi-tajekoztato"
        />

        <meta
          property="og:title"
          content="Adatvédelmi tájékoztató – DentiCare Fogászat"
        />
        <meta
          property="og:description"
          content="Részletes adatkezelési tájékoztató a DentiCare fogászati rendelő páciensei számára."
        />
        <meta
          property="og:url"
          content="https://denticare.hu/adatvedelmi-tajekoztato"
        />
        <meta property="og:image" content="https://denticare.hu/og.png" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="container text-center d-flex flex-column align-items-center mt-5 py-5">
        <h1 className="legal-header mb-4 pt-5">Adatvédelmi tájékoztató</h1>

        <p className="legal-intro">
          A jelen tájékoztató célja, hogy bemutassa a denticare.hu weboldalon
          keresztül megvalósuló adatkezelés szabályait a GDPR és az Info tv.
          rendelkezéseivel összhangban.
        </p>

        <div className="legal-card">
          <h3>1. Adatkezelő</h3>
          <p>
            <strong>Név:</strong> Re-Vi Dent bt. <br />
            <strong>Székhely:</strong> 5000, Szolnok Tompa Mihály utca 2. <br />
            <strong>Adószám:</strong> 20631064-1-16 <br />
          </p>

          <h3>2. Kezelt adatok köre</h3>
          <ul className="list-unstyled">
            <li>Név</li>
            <li>Telefonszám</li>
            <li>E-mail cím</li>
            <li>Üzenet, panasz vagy időpontkérés tartalma</li>
          </ul>

          <h3>3. Adatkezelés célja</h3>
          <p>
            Időpont-egyeztetés, pácienskapcsolat, visszahívás, valamint
            egészségügyi szolgáltatás előkészítése.
          </p>

          <h3>4. Jogalap</h3>
          <p>GDPR 6. cikk (1) a) – az érintett önkéntes hozzájárulása.</p>

          <h3>5. Megőrzési idő</h3>
          <p>
            Az adatokat legfeljebb 90 napig őrizzük meg, kivéve jogszabályi
            kötelezettség esetén.
          </p>

          <h3>6. Adatfeldolgozó</h3>
          <p>
            <strong>Amazon Web Services (AWS)</strong> – tárhelyszolgáltatás
          </p>

          <h3>7. Érintetti jogok</h3>
          <ul className="list-unstyled">
            <li>Tájékoztatáshoz való jog</li>
            <li>Hozzáféréshez való jog</li>
            <li>Helyesbítés</li>
            <li>Törlés</li>
            <li>Adatkezelés korlátozása</li>
            <li>Tiltakozás</li>
          </ul>

          <h3>8. Jogorvoslat</h3>
          <p>
            Panasz esetén a Nemzeti Adatvédelmi és Információszabadság
            Hatósághoz (NAIH) fordulhat:
          </p>
          <p>
            1055 Budapest, Falk Miksa utca 9-11. <br />
            <a href="https://www.naih.hu" target="_blank" rel="noreferrer">
              www.naih.hu
            </a>
          </p>

          <h3>9. Cookie-k</h3>
          <p>
            A weboldal működéséhez szükséges sütiket használunk. A hozzájárulás
            cookie banner segítségével történik.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
